import { norm } from "../utils/text.js";

export function tpKey(row){
  if (row?.tp_key != null && String(row.tp_key).trim() !== "") {
    return String(row.tp_key).trim();   // ✅ entscheidend
  }

  const sat = String(row?.sat_pos ?? "").trim();
  const f = Math.round(Number(row?.frequency_MHz ?? row?.frequency ?? 0));
  const p = norm(row?.pol ?? "");
  const sr = Math.round(Number(row?.symbolrate_kSps ?? row?.sr ?? 0));
  return `${sat}|${f}|${p}|${sr}`;
}